import React from 'react';
// import Checkbox from '../../../../components/forms/Checkbox';
import Checkbox from "../../../../features/customize-button/components/form/Checkbox";

const OptionsList = ({ list, title, onChange }) => {
  return (
    <>
      {list.length !== 0 && (
        <p className="destination-filter__title">{title}</p>
      )}
      <div className="col-wrap destination-filter__list">
        {list
          .filter(({ hideByType }) => !hideByType)
          .slice(0, 12)
          .map((item, index) => (
            <Checkbox
              key={index}
              label={item.name || item.value}
              checked={!!item.active}
              onChange={() => onChange(item.id)}
              wrapClassNames={'mb-3'}
            />
          ))}
      </div>
    </>
  );
};

export default OptionsList;
